import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './components/LoginScreen';
import GameHub from './components/GameHub';
import KingdomSelection from './components/KingdomSelection';
import Lobby from './components/Lobby';
import GameTable from './components/GameTable';
import TonLobby from './components/ton/TonLobby';
import TonGame from './components/ton/TonGame';
import BhLobby from './components/bh/BhLobby';
import BhGame from './components/bh/BhGame';
import CcLobby from './components/cc/CcLobby';
import CcGame from './components/cc/CcGame';
import DevBattlePreview from './DevBattlePreview';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [gameId, setGameId] = useState(null);
  const [tonGameId, setTonGameId] = useState(null);
  const [bhGameId, setBhGameId] = useState(null);
  const [ccGameId, setCcGameId] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('tlk_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('tlk_user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    setGameId(null);
    localStorage.removeItem('tlk_user');
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Anteprima delle scene 3D: solo in sviluppo, non finisce online */}
          {process.env.NODE_ENV !== 'production' && (
            <Route path="/anteprima" element={<DevBattlePreview />} />
          )}

          {/* Login */}
          <Route path="/" element={
            !user ? <LoginScreen onLogin={handleLogin} /> : <Navigate to="/games" />
          } />

          {/* Game Hub — scelta del gioco */}
          <Route path="/games" element={
            user ? <GameHub user={user} onLogout={handleLogout} /> : <Navigate to="/" />
          } />

          {/* The Last Kingdom flow */}
          <Route path="/kingdom" element={
            user ? <KingdomSelection user={user} /> : <Navigate to="/" />
          } />
          <Route path="/lobby" element={
            user ? <Lobby user={user} onGameStart={setGameId} /> : <Navigate to="/" />
          } />
          <Route path="/game/:gameId" element={
            user ? <GameTable user={user} onLogout={handleLogout} /> : <Navigate to="/" />
          } />
          <Route path="/ton/lobby" element={
            user ? <TonLobby user={user} onGameStart={setTonGameId} /> : <Navigate to="/" />
          } />
          <Route path="/ton/game/:gameId" element={
            user ? <TonGame user={user} /> : <Navigate to="/" />
          } />
          <Route path="/bh/lobby" element={
            user ? <BhLobby user={user} onGameStart={setBhGameId} /> : <Navigate to="/" />
          } />
          <Route path="/bh/game/:gameId" element={
            user ? <BhGame user={user} /> : <Navigate to="/" />
          } />
          <Route path="/cc/lobby" element={
            user ? <CcLobby user={user} onGameStart={setCcGameId} /> : <Navigate to="/" />
          } />
          <Route path="/cc/game/:gameId" element={
            user ? <CcGame user={user} /> : <Navigate to="/" />
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
